var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.148,
    height: 11.375,
    viewBox: "0 0 35.148 11.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "left",
    d: "M3.359-1.883H8.336V0H1.016V-11.375H3.359ZM16.523-4.93h-4.5v3.047H17.3V0H9.68V-11.375h7.609v1.9H12.023v2.711h4.5Zm9,.281h-4.5V0H18.68V-11.375h7.406v1.9H21.023v2.938h4.5ZM36.164-9.477H32.68V0H30.336V-9.477H26.9v-1.9h9.266Z",
    transform: "translate(-1.016 11.375)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.f770b7e14bc09c5560d58a73983c8ef5.svg";
export { ForwardRef as ReactComponent };